import React, { useEffect, useState } from 'react';
import IssueApi from '@/fetch/bussiness/issue';
import Label from '@/components/Label';
import { Col, Empty, message, Row, Table } from 'antd';
import { columns } from './columns';
import { HttpStatusCode } from '@/fetch/core/constant';
import { clstagStr, isEmpty } from '@/utils/util';
import { formatDuration, showMsg } from '@/utils/util';
import { IssueStatus, IssueStatusText, IssueTypeText } from '@/utils/type';

import { useSelector } from 'react-redux';
import { showModal } from '@/components/Modal';
import CommonTitle from '@/components/CommonTitle';
import TimeLine from '@/components/TimeLine';
import TransferIssueModal from '@/components/TransferIssueModal';
import moment from 'moment';
import { RootState } from '@/redux/store';
import { CLSTAG, TicketOperation } from '@/utils/constant';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import { useIsTakeOverBySelf } from '@/utils/hooks';
const fetchApi = new IssueApi();

const IssueBoard = () => {
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const login = useSelector((state: RootState) => state.login);
  const { cockpitTeamNumber } = newCommon;
  const isTakeOverBySelf = useIsTakeOverBySelf();
  const [tableData, setTableData] = useState<any[]>([]);
  const [openAllocateModal, setOpenAllocateModal] = useState(false);
  const [selectIssue, setSelectIssue] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    getIssueList();
  }, []);
  const getIssueList = async () => {
    try {
      const res = await fetchApi.getCockpitTeamIssueList(cockpitTeamNumber);
      if (res.code === HttpStatusCode.Success) {
        if (res?.data) {
          !isEmpty(res.data?.issueList) && setTableData(res.data?.issueList);
        } else {
          setTableData([]);
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const remindIssue = async (issueNumber: string, reminderUsername: string) => {
    try {
      const res = await fetchApi.remindIssue({ issueNumber, reminderUsername });
      if (res.code === HttpStatusCode.Success) {
        showMsg({
          msg: '催单成功',
          type: 'success',
        });
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const showIssueDetail = async (record: any) => {
    try {
      const res = await fetchApi.getIssueOperation({
        issueNumber: record.issueNumber,
      });
      if (res.code === HttpStatusCode.Success) {
        const list: any[] = [];
        if (!isEmpty(res.data?.issueOperationList)) {
          res.data.issueOperationList.forEach((item: any) => {
            list.push({
              ...item,
              operationType: TicketOperation.get(item.operationType)?.name,
            });
          });
        }
        showModal({
          title: '工单明细',
          width: 1200,
          footer: {
            showCancel: true,
            showOk: false,
            cancelFunc: (cb) => cb(),
            cancelText: '关闭',
          },
          content: (
            <>
              <Row justify={'space-evenly'} style={{ marginBottom: '12px' }}>
                <Col>
                  <div className="label">
                    工单编号
                    <span className="content">{record.issueNumber}</span>
                  </div>
                </Col>
                <Col>
                  <div className="label">
                    工单状态
                    <span className="content">
                      {IssueStatusText.get(record.issueStatus)}
                    </span>
                  </div>
                </Col>
                <Col>
                  <div className="label">
                    工单创建时间
                    <span className="content">{record.issueCreateTime}</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ marginBottom: '12px' }}>
                  <CommonTitle title="处理历史" />
                </Col>
                <Col>
                  {!isEmpty(res.data.issueOperationList) ? (
                    <TimeLine list={list} />
                  ) : (
                    <Empty
                      description={<p style={{ color: '#fff' }}>暂无数据</p>}
                    />
                  )}
                </Col>
              </Row>
            </>
          ),
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  const formatColumns = () => {
    return columns.map((column: any) => {
      switch (column.dataIndex) {
        case 'vehicleName':
          return {
            ...column,
            render: (text: any, record: any) => {
              if (record?.vehicleName) {
                return (
                  <a
                    className="link-vehicle-name"
                    onClick={() => {
                      if (isTakeOverBySelf) {
                        message.error('您已在接管车辆中，请先退出接管');
                        return;
                      }
                      navigate(
                        `/app/singleview?vehicleName=${record.vehicleName}`
                      );
                    }}
                  >
                    {record?.vehicleName}
                  </a>
                );
              } else {
                return <>--</>;
              }
            },
          };
        case 'eventList':
          return {
            ...column,
            render: (text: any, record: any) => {
              if (!isEmpty(record?.eventList)) {
                return record.eventList.map((event: any) => {
                  return <Label text={event} key={event}></Label>;
                });
              } else {
                return <>-</>;
              }
            },
          };
        case 'issueType':
          return {
            ...column,
            render: (text: any, record: any) => {
              return <>{IssueTypeText[record.issueType]}</>;
            },
          };
        case 'issueDuration':
          return {
            ...column,
            render: (text: any, record: any) => {
              return (
                <>
                  {formatDuration(
                    record.issueCreateTime,
                    record.issueEndTime ??
                      moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                  )}
                </>
              );
            },
          };
        case 'issueStatus':
          return {
            ...column,
            render: (text: any, record: any) => {
              return <>{IssueStatusText.get(record.issueStatus)}</>;
            },
          };
        case 'operations':
          return {
            ...column,
            render: (text: any, record: any) => {
              // 软件提报不展示派单按钮
              if (record.issueType === 'BUG_REPORT') {
                return null;
              }
              return (
                <>
                  {(record.issueStatus === IssueStatus.TO_ASSIGN ||
                    record.issueStatus === IssueStatus.DISCARD_WAIT_ASSIGN) && (
                    <span
                      style={{
                        marginRight: '12px',
                        color: '#0d85ff',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setSelectIssue(record.issueNumber);
                        setOpenAllocateModal(true);
                      }}
                    >
                      派单
                    </span>
                  )}
                  {!record.remind &&
                    (record.issueStatus === IssueStatus.PROCESS ||
                      record.issueStatus === IssueStatus.ON_HOLD) && (
                      <span
                        style={{ color: '#0d85ff', cursor: 'pointer' }}
                        onClick={() => {
                          remindIssue(
                            record.issueNumber,
                            login?.userInfo?.userName
                          );
                        }}
                        clstag={clstagStr(CLSTAG.WorkOrderBoard_RemindIssue)}
                      >
                        催单
                      </span>
                    )}
                  {record.remind && <>已催单</>}
                  <span
                    style={{
                      marginLeft: '12px',
                      color: '#0d85ff',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      showIssueDetail(record);
                    }}
                    clstag={clstagStr(CLSTAG.WorkOrderBoard_CheckWorkOrder)}
                  >
                    查看工单
                  </span>
                </>
              );
            },
          };
        default:
          return column;
      }
    });
  };
  return (
    <>
      <Table
        dataSource={tableData}
        columns={formatColumns()}
        pagination={false}
        scroll={{
          y: 800,
        }}
        rowKey="issueNumber"
      ></Table>
      <TransferIssueModal
        open={openAllocateModal}
        setOpen={setOpenAllocateModal}
        type="ALLOCATE"
        issueNumber={selectIssue}
        updateList={getIssueList}
      ></TransferIssueModal>
    </>
  );
};
export default React.memo(IssueBoard);
